import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../../components/layout/Layout';
import { PageHeader } from '../../../components/layout/PageHeader';
import { Card, CardContent } from '../../../components/ui/Card';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../../components/ui/Table';
import { Button } from '../../../components/ui/Button';
import { listEmailTemplates } from '../../../modules/comms/api/comms.gateway';
import { EmailTemplate } from '../../../modules/comms/types';
import { Spinner } from '../../../components/ui/Spinner';
import { showErrorToast } from '../../../utils/errorHandler';
import { EmailTemplateModal } from './EmailTemplateModal';

export const EmailTemplatesPage: React.FC = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<EmailTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState<EmailTemplate | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await listEmailTemplates();
        setTemplates(data || []);
      } catch (err) {
        showErrorToast(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const refresh = async () => {
    setLoading(true);
    try {
      const data = await listEmailTemplates();
      setTemplates(data || []);
    } catch (err) {
      showErrorToast(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader title="Email Templates" subtitle="Manage email templates" />
      <Card>
        <CardContent>
            <div className="flex justify-end mb-4">
            <Button onClick={() => navigate('new')}>Create</Button>
          </div>

          {loading ? (
            <div className="flex justify-center py-8"><Spinner size="lg" /></div>
          ) : templates.length === 0 ? (
            <div className="text-center py-8 text-gray-500">No templates found.</div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Key</TableHead>
                  <TableHead>Name</TableHead>
                  <TableHead>Tenant</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {templates.map((t) => (
                  <TableRow key={t.id}>
                    <TableCell className="font-medium">{t.template_key}</TableCell>
                    <TableCell>{t.name}</TableCell>
                    <TableCell>{t.tenant_id || 'Global'}</TableCell>
                    <TableCell>
                      <Button variant="ghost" size="sm" onClick={() => { setEditing(t); setModalOpen(true); }}>Edit</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
      <EmailTemplateModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initial={editing}
        onSaved={refresh}
      />
    </Layout>
  );
};


